// extracted by mini-css-extract-plugin
module.exports = {"cover":"GridPhotos_cover__2P9t-","legend":"GridPhotos_legend__1Vw3g","galery":"GridPhotos_galery__2o_7Y","galery__item":"GridPhotos_galery__item__ysig5"};